import find from 'lodash/find';
import get from 'lodash/get';
import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import constants from './Coupon.config';

// Page is boolean value, if true, we load page level and we don't set apply method
export const createCardRewards = (adjustment, method, bem, page) => {
    const couponRewardItem = {};
    const couponCode = `${adjustment.value}-${constants.TOF}`;
    const description = `${adjustment.description}`;
    couponRewardItem.couponCode = couponCode.toLowerCase();
    couponRewardItem.couponEligible = adjustment.amount ? constants.YES : constants.NO;
    couponRewardItem.couponType = description.toLowerCase();
    couponRewardItem.couponAmount = `${adjustment.amount}`;
    if (adjustment.amount > 0) {
        const discount = find(adjustment.analyticsAttributes, { type: 'couponDiscount' });
        /* istanbul ignore next */
        couponRewardItem.couponDiscount = get(discount, 'value', 0);
    }

    /* istanbul ignore else */
    if (!page) {
        couponRewardItem.couponApplyMethod = `${method}`.toLowerCase();
        couponRewardItem.bem = bem;
    }
    couponRewardItem.rewardRedemptionID = constants.EMPTY;
    couponRewardItem.rewardValid = constants.EMPTY;
    couponRewardItem.rewardType = constants.EMPTY;
    couponRewardItem.rewardAmount = constants.EMPTY;
    couponRewardItem.rewardApplyMethod = constants.EMPTY;
    return couponRewardItem;
};

class CouponActionFilter extends BaseActionFilter {
    // on click of Apply coupon, trigger this function
    static getCouponDL = (store, analyticsEventName = '') => {
        const state = store.getState();
        const couponRewardsInfo = [];
        const COUPON_APPLIED = 'couponApplied';
        if (state.appliedAdjustments && state.appliedAdjustments.length > 0) {
            const adjustment = state.appliedAdjustments[0];
            let method = '';
            if (state.isAdjustmentsUpdated.method) {
                method = state.isAdjustmentsUpdated.method;
            }
            const category = state.isAdjustmentsUpdated.category || '';
            const couponCode = `${adjustment.value}`;
            const { pageType } = get(window.digitalData, 'page.pageInfo', {});
            const slot = state.isAdjustmentsUpdated.slot || 0;
            const bem =
                analyticsEventName === COUPON_APPLIED
                    ? `${COUPON_APPLIED}|${category}|slot-${slot}`
                    : `couponRemoved|${couponCode.toLowerCase()}|${pageType}`;
            const result = createCardRewards(adjustment, method, bem, false);
            couponRewardsInfo.push(result);
        }
        const commonDigitalData = {
            cart: {
                couponRewardsInfo,
            },
        };
        return commonDigitalData;
    };
}

export default CouponActionFilter;
